module.exports = __webpack_public_path__ + "img/17.56161984.png";